export default __webpack_public_path__ + "static/media/rectangle.4c4c29cf.png";